import axios from 'axios';
import {supplier_arry} from "config"

export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_PRODUCT_UPLOADED = 'SET_PRODUCT_UPLOADED';
export const SET_COLOURS = 'SET_COLOURS';
export const SET_SIZES = 'SET_SIZES';
export const UPDATE_CAT = 'UPDATE_CAT';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const INIT_PRODUCTS = 'INIT_PRODUCTS';
export const UPDATE_QUOTE = 'UPDATE_QUOTE';
export const INIT_QUOTE = 'INIT_QUOTE';
export const SET_LOGO = 'SET_LOGO';
export const SET_CONTACTUSER = 'SET_CONTACTUSER';
export const SET_CONTACTADDRESS = 'SET_CONTACTADDRESS';
export const SET_CONTACTINFO = 'SET_CONTACTINFO';
export const SET_QUOTE_COMPANY = 'SET_QUOTE_COMPANY';
export const SET_VALID_DATE = 'SET_VALID_DATE'
export const SET_QUOTE_LABEL = 'SET_QUOTE_LABEL'
export const SET_CLIENT_ORDER_NUMBER = 'SET_CLIENT_ORDER_NUMBER'
export const SET_CLIENT_LABEL = 'SET_CLIENT_LABEL'
export const SET_TOTAL_PRICE = 'SET_TOTAL_PRICE'
export const SET_TOTAL_PRICE_EX = 'SET_TOTAL_PRICE_EX'
export const SET_TOTAL_ACCEPTED_PRICE = 'SET_TOTAL_ACCEPTED_PRICE'
export const SET_GST = 'SET_GST'
export const SET_DELIVERY_REQUIRED = 'SET_DELIVERY_REQUIRED'
export const SET_PICKUP_INSTORE = 'SET_PICKUP_INSTORE'
export const SET_COLLECTION_ID = 'SET_COLLECTION_ID'
export const SET_QUOTE_ID = 'SET_QUOTE_ID'
export const SET_REVISE = 'SET_REVISE'
export const SET_CUSTOMERS = 'SET_CUSTOMERS'
export const SET_MARGIN_VALUE = 'SET_MARGIN_VALUE'
export const SET_MARGIN_PERCENT = 'SET_MARGIN_PERCENT'
export const SET_COMPANY_UPDATED = 'SET_COMPANY_UPDATED'
export const SET_CONTACT_UPDATED = 'SET_CONTACT_UPDATED'
export const SET_LOADING = 'SET_LOADING'
export const SET_DEFAULT_BRAND = 'SET_DEFAULT_BRAND'
export const SET_COMPANY = 'SET_COMPANY'
// LOADING
export const SET_COMPANY_LOADING = 'SET_COMPANY_LOADING'
export const SET_QUOTE_LOADING = 'SET_QUOTE_LOADING'
export const SET_TEMPLATE_LOADING = 'SET_TEMPLATE_LOADING'
export const SET_PRODUCTION_LOADING = 'SET_PRODUCTION_LOADING'
export const SET_SETTING_LOADING = 'SET_SETTING_LOADING'
export const SET_OPEN_CONFIRM_EDIT_MODAL = 'SET_OPEN_CONFIRM_EDIT_MODAL'
//-------------------------------------

export const setOpenConfirmEditModal = data =>({
    type:SET_OPEN_CONFIRM_EDIT_MODAL,
    payload:data
});
export const setLoading = data =>({
    type:SET_LOADING,
    payload:data
});
export const setCompanyLoaded = data =>({
    type:SET_COMPANY_LOADING,
    payload:data
});
export const setQuoteLoading = data =>({
    type:SET_QUOTE_LOADING,
    payload:data
});
export const setTemplateLoading = data =>({
    type:SET_TEMPLATE_LOADING,
    payload:data
});
export const setProductionLoading = data =>({
    type:SET_PRODUCTION_LOADING,
    payload:data
});

export const setSettingLoading = data =>({
    type:SET_SETTING_LOADING,
    payload:data
});

export const setProducts = data =>({
    type:SET_PRODUCTS,
    payload:data
});

export const setProductUploaded = data =>({
    type:SET_PRODUCT_UPLOADED,
    payload:data
});

export const setColours = data =>({
    type:SET_COLOURS,
    payload:data
});

export const setSizes = data =>({
    type:SET_SIZES,
    payload:data
});

export const setRevise = data =>({
    type:SET_REVISE,
    payload:data
});

export const updateCategory = category =>({
    type:UPDATE_CAT,
    payload:category
});

export const addProduct = (category, product) =>({
    type:ADD_PRODUCT,
    payload:{category, product}
});
export const setDefaultBrand = (data) =>({
    type:SET_DEFAULT_BRAND,
    payload:data
})
export const initProducts = () =>({
    type:INIT_PRODUCTS,
    payload:null
});
export const setQuote = quote =>({
    type:UPDATE_QUOTE,
    payload:quote
});
export const initQuote = () =>({
    type:INIT_QUOTE,
    payload:''
});
export const setLogo = (data) =>({
    type:SET_LOGO,
    payload:data
})
export const setSelectedContactUser = (data) =>({
    type:SET_CONTACTUSER,
    payload:data
})
export const setSelectedContactInfo = (data) =>({
    type:SET_CONTACTINFO,
    payload:data
})
export const setSelectedContactAddress = (data) =>({
    type:SET_CONTACTADDRESS,
    payload:data
})
export const setSelectedCompany = (data) =>({
    type:SET_COMPANY,
    payload:data
})
export const setValidDate = (data) =>({
    type:SET_VALID_DATE,
    payload:data
})
export const setQuoteLabel = (value) =>({
    type:SET_QUOTE_LABEL,
    payload:value
})
export const setClientOrderNumber = (value) =>({
    type:SET_CLIENT_ORDER_NUMBER,
    payload:value
})
export const setQuoteClientLabel = (value) =>({
    type:SET_CLIENT_LABEL,
    payload:value
})

export const setTotalPrice = (value) =>({
    type:SET_TOTAL_PRICE,
    payload:value
})

export const setTotalPriceExGst = (value) =>({
    type:SET_TOTAL_PRICE_EX,
    payload:value
})
export const setMarginPercent = (value) =>({
    type:SET_MARGIN_PERCENT,
    payload:value
})
export const setMarginValue = (value) =>({
    type:SET_MARGIN_VALUE,
    payload:value
})
export const setTotalAcceptedPrice = (value) =>({
    type:SET_TOTAL_ACCEPTED_PRICE,
    payload:value
})
export const setGst = (value) =>({
    type:SET_GST,
    payload:value
})
export const setDeliveryRequired = (data) =>({
    type:SET_DELIVERY_REQUIRED,
    payload:data
})
export const setPickupInstore = (data) =>({
    type:SET_PICKUP_INSTORE,
    payload:data
})
export const setCollectionId = (data) =>({
    type:SET_COLLECTION_ID,
    payload:data
})
export const setQuoteId = (data) =>({
    type:SET_QUOTE_ID,
    payload:data
})
export const setCompanies = (data) =>({
    type:SET_CUSTOMERS,
    payload:data
})
export const setContactUpdated = (data) =>({
    type:SET_CONTACT_UPDATED,
    payload:data
})
export const setCompanyUpdated = (data) =>({
    type:SET_COMPANY_UPDATED,
    payload:data
})
export const setCompany = (data) =>({
    type:SET_QUOTE_COMPANY,
    payload:data
})



export const uploadProducts = () =>{
    return dispatch => {
        var category1 = supplier_arry[0]
        axios.get(`/products/getproductlist/${category1.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category1.key, products:data.products}))
                dispatch(setColours({category: category1.key, colournames:data.colornames}))
                dispatch(setSizes({category: category1.key, sizenames:data.sizenames}))
            }
        })    
        var category2 = supplier_arry[1]
        axios.get(`/products/getproductlist/${category2.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category2.key, products:data.products}))
                dispatch(setColours({category: category2.key, colournames:data.colornames}))
                dispatch(setSizes({category: category2.key, sizenames:data.sizenames}))
            }
        })    
        var category3 = supplier_arry[2]
        axios.get(`/products/getproductlist/${category3.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category3.key, products:data.products}))
                dispatch(setColours({category: category3.key, colournames:data.colornames}))
                dispatch(setSizes({category: category3.key, sizenames:data.sizenames}))
            }
        })    
        var category4 = supplier_arry[3]
        axios.get(`/products/getproductlist/${category4.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category4.key, products:data.products}))
                dispatch(setColours({category: category4.key, colournames:data.colornames}))
                dispatch(setSizes({category: category4.key, sizenames:data.sizenames}))
            }
        })    
        var category5 = supplier_arry[4]
        axios.get(`/products/getproductlist/${category5.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category5.key, products:data.products}))
                dispatch(setColours({category: category5.key, colournames:data.colornames}))
                dispatch(setSizes({category: category5.key, sizenames:data.sizenames}))
            }
        })    
        var category6 = supplier_arry[5]
        axios.get(`/products/getproductlist/${category6.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category6.key, products:data.products}))
                dispatch(setColours({category: category6.key, colournames:data.colornames}))
                dispatch(setSizes({category: category6.key, sizenames:data.sizenames}))
            }
        })    
        var category7 = supplier_arry[6]
        axios.get(`/products/getproductlist/${category7.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category7.key, products:data.products}))
                dispatch(setColours({category: category7.key, colournames:data.colornames}))
                dispatch(setSizes({category: category7.key, sizenames:data.sizenames}))
            }
        })    
        var category8 = supplier_arry[7]
        axios.get(`/products/getproductlist/${category8.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category8.key, products:data.products}))
                dispatch(setColours({category: category8.key, colournames:data.colornames}))
                dispatch(setSizes({category: category8.key, sizenames:data.sizenames}))
            }
        })    
        var category9 = supplier_arry[8]
        axios.get(`/products/getproductlist/${category9.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category9.key, products:data.products}))
                dispatch(setColours({category: category9.key, colournames:data.colornames}))
                dispatch(setSizes({category: category9.key, sizenames:data.sizenames}))
            }
        })    
        var category10 = supplier_arry[9]
        axios.get(`/products/getproductlist/${category10.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category10.key, products:data.products}))
                dispatch(setColours({category: category10.key, colournames:data.colornames}))
                dispatch(setSizes({category: category10.key, sizenames:data.sizenames}))
            }
        })    
        var category11 = supplier_arry[10]
        axios.get(`/products/getproductlist/${category11.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category11.key, products:data.products}))
                dispatch(setColours({category: category11.key, colournames:data.colornames}))
                dispatch(setSizes({category: category11.key, sizenames:data.sizenames}))
            }
        })    
        var category12 = supplier_arry[11]
        axios.get(`/products/getproductlist/${category12.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category12.key, products:data.products}))
                dispatch(setColours({category: category12.key, colournames:data.colornames}))
                dispatch(setSizes({category: category12.key, sizenames:data.sizenames}))
            }
        })    
        var category13 = supplier_arry[12]
        axios.get(`/products/getproductlist/${category13.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category13.key, products:data.products}))
                dispatch(setColours({category: category13.key, colournames:data.colornames}))
                dispatch(setSizes({category: category13.key, sizenames:data.sizenames}))
            }
        })    
        var category14 = supplier_arry[13]
        axios.get(`/products/getproductlist/${category14.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category14.key, products:data.products}))
                dispatch(setColours({category: category14.key, colournames:data.colornames}))
                dispatch(setSizes({category: category14.key, sizenames:data.sizenames}))
            }
        })    
        var category15 = supplier_arry[14]
        axios.get(`/products/getproductlist/${category15.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category15.key, products:data.products}))
                dispatch(setColours({category: category15.key, colournames:data.colornames}))
                dispatch(setSizes({category: category15.key, sizenames:data.sizenames}))
            }
        })    
        var category16 = supplier_arry[15]
        axios.get(`/products/getproductlist/${category16.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category16.key, products:data.products}))
                dispatch(setColours({category: category16.key, colournames:data.colornames}))
                dispatch(setSizes({category: category16.key, sizenames:data.sizenames}))
            }
        })   
          
        var category17 = supplier_arry[16]
        axios.get(`/products/getproductlist/${category17.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category17.key, products:data.products}))
                dispatch(setColours({category: category17.key, colournames:data.colornames}))
                dispatch(setSizes({category: category17.key, sizenames:data.sizenames}))
            }
        })   
          
        var category18 = supplier_arry[17]
        axios.get(`/products/getproductlist/${category18.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category18.key, products:data.products}))
                dispatch(setColours({category: category18.key, colournames:data.colornames}))
                dispatch(setSizes({category: category18.key, sizenames:data.sizenames}))
            }
        })    
        var category19 = supplier_arry[18]
        axios.get(`/products/getproductlist/${category19.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category19.key, products:data.products}))
                dispatch(setColours({category: category19.key, colournames:data.colornames}))
                dispatch(setSizes({category: category19.key, sizenames:data.sizenames}))
            }
        })    
        var category20 = supplier_arry[19]
        axios.get(`/products/getproductlist/${category20.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category20.key, products:data.products}))
                dispatch(setColours({category: category20.key, colournames:data.colornames}))
                dispatch(setSizes({category: category20.key, sizenames:data.sizenames}))
            }
        }) 
        
        var category21 = supplier_arry[20]
        axios.get(`/products/getproductlist/${category21.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category21.key, products:data.products}))
                dispatch(setColours({category: category21.key, colournames:data.colornames}))
                dispatch(setSizes({category: category21.key, sizenames:data.sizenames}))
            }
        }) 

        var category22 = supplier_arry[21]
        axios.get(`/products/getproductlist/${category22.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category22.key, products:data.products}))
                dispatch(setColours({category: category22.key, colournames:data.colornames}))
                dispatch(setSizes({category: category22.key, sizenames:data.sizenames}))
            }
        }) 

        var category23 = supplier_arry[22]
        axios.get(`/products/getproductlist/${category23.key}`).then(res => {
            if(res.data.status == "success"){
                var data = res.data.data;
                dispatch(setProducts({category: category23.key, products:data.products}))
                dispatch(setColours({category: category23.key, colournames:data.colornames}))
                dispatch(setSizes({category: category23.key, sizenames:data.sizenames}))
            }
        }) 

        dispatch(setProductUploaded(true))
    }
}